import { useState } from "react";
import {
  TextArea,
  type TextAreaChangeEvent,
} from "@progress/kendo-react-inputs";

interface TextAreaInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  labelSuffix?: string;
  rows?: number;
  maxLength?: number;
  showLenth?: boolean;
  validationMessage?: string;
  placeholder?: string;
  required?: boolean;
}
const TextAreaInput = ({
  value,
  onChange,
  label,
  rows,
  maxLength = 500,
  validationMessage,
  placeholder,
  labelSuffix,
  showLenth = true,
  required,
}: TextAreaInputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleOnchange = (event: TextAreaChangeEvent) => {
    onChange(event.value);
  };

  return (
    <div
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      className="relative w-full numeric-textbox login-no-img"
    >
      <label
        className={`input-label-answer input-label-textarea gx-font-semibold ${
          isFocused || value ? "floating" : "default"
        }`}
      >
        {label}
        {labelSuffix && (
          <span className="label-suffix italic text-[#999999]">
            ({labelSuffix})
          </span>
        )}
        {required && <span className="label-suffix text-[#FF0000]">*</span>}
      </label>
      <div
        className={`input-label-textareas ${
          !validationMessage || value ? "valid" : "invalid"
        }`}
      >
        <TextArea
          value={value}
          onChange={handleOnchange}
          maxLength={maxLength}
          rows={rows}
          autoSize={false}
          placeholder={placeholder}
          className="gx-textbox-css custom-textarea-scroll gx-font-semibold"
        />

        {showLenth && (
          <span className="gx-textbox-css-total gx-font-medium">
            {value?.length}/{maxLength}
          </span>
        )}
      </div>

      {validationMessage && (
        <p className="mt-1 text-xs text-red-500 flex gx-font-regular">
          {validationMessage}
        </p>
      )}
    </div>
  );
};

export default TextAreaInput;
